export default "/_next/static/chunks/fonts/lato-300-italic-d57198714da54c4188559ca2b36fd7af.woff2";